
//Default to test data
const dataReducerDefaultState = {
    isDownloaded : false
};

export default (state = dataReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_DOWNLOAD_FILE':
            return {
                ...state,
                isDownloaded : action.isDownloaded
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/Reducers/download.js